export default __webpack_public_path__ + "static/media/green-uld-pin.8bbdf466.svg";